'use client'

import { useSyncExternalStore } from 'react'

import { DESKTOP_MIN_WIDTH } from '@/app/lib/hooks/useResponsiveColumns'

const QUERY = `(min-width: ${DESKTOP_MIN_WIDTH}px)`

function subscribe(callback: () => void): () => void {
  const query = window.matchMedia(QUERY)
  query.addEventListener('change', callback)
  return () => query.removeEventListener('change', callback)
}

function getSnapshot(): boolean {
  return window.matchMedia(QUERY).matches
}

/** Mobile-first: sin `window` (servidor / primer render de cliente antes de
 * hidratar), se asume que no es desktop. */
function getServerSnapshot(): boolean {
  return false
}

/**
 * `true` a partir de 1024px (mismo umbral que `useResponsiveColumns` y que el
 * selector de vista horizontal/vertical de `ListingFilters`, oculto por
 * debajo). `useSyncExternalStore` (en vez de `useState` + `useEffect` con
 * `setState` síncrono) es el primitivo correcto para suscribirse a un origen
 * externo como `matchMedia` — evita el patrón de renders en cascada que
 * `react-hooks/set-state-in-effect` marca como error.
 *
 * Páginas con selector de vista (agenda/lo-mas-vendido/postsale/search) lo
 * usan para forzar `VerticalCard` en mobile/tablet con independencia del
 * `viewMode` que hubiera quedado en `ViewModeContext` — p. ej. tras elegir
 * horizontal en desktop y luego reducir la ventana
 * (specs/019-estados-compra-eventos).
 */
export function useIsDesktopViewport(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
